import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/sales-rm-targets';
const TEAM_BASE = '/api/v1/admin/mtd-business-report/team-members';

function unwrap(body) {
  if (body?.success === false) {
    const msg = body?.message;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }
  return body?.data ?? body;
}

const salesRmTargetService = {
  listTeamMembers: async () => {
    const response = await apiClient.get(TEAM_BASE);
    return unwrap(response.data);
  },

  listTargets: async ({ periodYear, periodMonth }) => {
    const response = await apiClient.get(BASE, {
      params: { period_year: periodYear, period_month: periodMonth },
    });
    const data = unwrap(response.data);
    return data?.targets ?? [];
  },

  upsertTargets: async (targets) => {
    const response = await apiClient.put(BASE, { targets });
    return response.data;
  },

  copyFromPreviousMonth: async ({ periodYear, periodMonth }) => {
    const response = await apiClient.post(`${BASE}/copy-from-previous-month`, {
      period_year: periodYear,
      period_month: periodMonth,
    });
    return unwrap(response.data);
  },
};

export default salesRmTargetService;
